import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Route, NavLink } from "react-router-dom";
import {
  Navbar,
  Nav,
  NavItem,
  NavbarToggler,
  Collapse,
  Media
} from "reactstrap";

import AllSpecifications from "./AllSpecifications/AllSpecifications";
import SpecificationData from "./AllSpecifications/SpecificationData";
import FAQ from "./FAQ/FAQ";
import FAQEn from "./FAQ/FAQEn";
import LastUpdates from "./LastUpdates/LastUpdates";
import Publications from "./Publications/Publications";
import ContactUs from "./ContactUs/ContactUs";
import Search from "./Search/Search";
import Home from "./Home/Home";
import MailingList from "./MailingList";
import AccessabilityDeclaration from "./Accessability/AccessabilityDeclaration";
import AriaMenu from "./Accessability/AriaMenu";

import createHistory from "history/createBrowserHistory";
import ReactGA from "react-ga";

import search from "./images/search.png";

import classes from "./Menu.module.scss";
import ScrollToTop from "./ScrollToTop";

class BinuyMenu extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.closeNavbar = this.closeNavbar.bind(this);
    this.state = {
      isOpen: false
    };
    const history = createHistory();
    history.listen(location => {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
    });
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  closeNavbar() {
    if (this.state.isOpen == true) {
      this.toggle();
    }
  }
  render() {
    //var history = createHistory();
    return (
      <BrowserRouter onUpdate={() => window.scrollTo(0, 0)}>
        <ScrollToTop>
          <div>
            <div className={classes.mainMenu}>
              <Navbar className={classes.navBar} dark expand="lg">
                <NavbarToggler onClick={this.toggle} />
                <Collapse
                  className={classes.navbarCollapse}
                  isOpen={this.state.isOpen}
                  navbar
                >
                  <Nav navbar>
                    <NavItem className={classes.first}>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/" }}
                        activeClassName={classes.active}
                        exact
                      >
                        ראשי
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/AllSpecifications" }}
                        activeClassName={classes.active}
                      >
                        כל הפרקים
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/LastUpdates" }}
                        activeClassName={classes.active}
                      >
                        פרסומים אחרונים
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/Publications" }}
                        activeClassName={classes.active}
                      >
                        לוח הפירסומים
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/FAQ" }}
                        activeClassName={classes.active}
                      >
                        שאלות ותשובות - FAQ
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/ContactUs" }}
                        activeClassName={classes.active}
                      >
                        צור קשר
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        onClick={this.closeNavbar}
                        to={{ pathname: "/Search" }}
                        activeClassName={classes.active}
                      >
                        <Media
                          object
                          alt="חיפוש במפרטים"
                          src={search}
                          className={classes.searchImg}
                        />
                        חיפוש
                      </NavLink>
                    </NavItem>
                  </Nav>
                </Collapse>
              </Navbar>
            </div>

            <div className={classes.mainContant}>
              <Route
                path="/AllSpecifications"
                exact
                component={AllSpecifications}
              />
              <Route
                path="/AllSpecifications/:id"
                component={SpecificationData}
              />
              <Route path="/LastUpdates" exact component={LastUpdates} />
              <Route path="/Publications" exact component={Publications} />
              <Route path="/FAQ" exact component={FAQ} />
              <Route path="/FAQEn" exact component={FAQEn} />
              <Route path="/ContactUs" exact component={ContactUs} />
              <Route path="/Search" exact component={Search} />
              <Route path="/MailingList" exact component={MailingList} />
              <Route
                path="/AccessabilityDeclaration"
                exact
                component={AccessabilityDeclaration}
              />
              <Route path="/" exact component={Home} />
            </div>
          </div>

          <AriaMenu />
        </ScrollToTop>
      </BrowserRouter>
    );
  }
}

export default connect(null, null)(BinuyMenu);
